import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import Swiper styles
import { Grid, IconButton } from "@material-ui/core";
import PortFolioItem from "./PortFolioItem";

import Swiper from "react-id-swiper";
import "swiper/swiper-bundle.css";
import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import clsx from "clsx";
const Background = "/images/abhipray/Intersect.png";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${Background})`,
    backgroundSize: `100% 100%`,
    backgroundRepeat: "no-repeat",
    height: "65vh",
  },
  description: {
    overflow: "hidden",
    display: "-webkit-box",

    height: "100%",
    // textOverflow: "ellipsis",
    // WebkitLineClamp: 5,
    // WebkitBoxOrient: "vertical",
  },
  caroiselContainer: {
    // backgroundColor: "red",
    height: "57vh",
    marginTop: "2vh",
    // width: "100%",
    // justifyContent: "center",
    // display: "flex",
    // alignItems: "center",
  },
  arrowIcon: {
    fontSize: "3rem",
    color: "white",
  },
  iconContainer: {
    height: "65vh",
  },
  dotItem: {
    height: "2vh",
    width: "2vh",
    borderRadius: 100,
    margin: 2,

    backgroundColor: "white",
  },
  activeDot: {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const AbhiprayCarousel = (props) => {
  const [firstSwiper, setFirstSwiper] = React.useState(null);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const swiperRef = React.useRef();
  const [currentIndex, updateCurrentIndex] = React.useState(0);
  const onChange = (e) => {
    setValue(e.target ? e.target.value : e);
  };
  const params = {
    direction: "vertical",
    slidesPerView: 2,

    spaceBetween: 10,
  };
  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
      console.log("swiper", swiperRef.current.swiper);
    }
  };
  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  const updateIndex = React.useCallback(
    () => updateCurrentIndex(swiperRef.current.swiper.realIndex),
    []
  );

  React.useEffect(() => {
    const swiperInstance = swiperRef.current.swiper;

    if (swiperInstance) {
      swiperInstance.on("slideChange", updateIndex);
    }

    return () => {
      if (swiperInstance) {
        swiperInstance.off("slideChange", updateIndex);
      }
    };
  }, [updateIndex]);
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid
          item
          lg={1}
          container
          alignItems="center"
          direction="column"
          justify="center"
          className={classes.iconContainer}
        >
          {props.data.map((man, index) => {
            return (
              <Grid
                item
                key={index}
                className={clsx(
                  classes.dotItem,
                  currentIndex === index ? classes.activeDot : undefined
                )}
              />
            );
          })}
        </Grid>
        <Grid
          item
          lg={9}
          container
          alignItems="center"
          justify="space-between"
          className={classes.caroiselContainer}
        >
          <Swiper
            {...params}
            ref={swiperRef}
            autoplay={{ delay: 500 }}
            loop={true}
            // activeSlideKey={value}
            // spaceBetween={10}
            wrapperClass={classes.caroiselContainer}
            // slidesPerView={2}
            // direction="vertical"
            // autoplay={{ delay: 2000, reverseDirection: true }}
            // navigation={{ nextEl: <div>next</div>, prevEl: <div>prev</div> }}
            // pagination={{ clickable: false }}
            // // scrollbar={{ draggable: true }}
            // onSwiper={(swiper) => console.log(swiper)}
            // onSlideChange={() => console.log("slide change")}
          >
            {props.data.map((man, index) => {
              return (
                <Grid item key={index}>
                  <PortFolioItem data={man} />
                </Grid>
              );
            })}
          </Swiper>
          {/* <Carousel
            infiniteLoop={true}
            dynamicHeight={true}
            autoPlay={true}
            // axis="vertical"
          >
           
          </Carousel> */}
        </Grid>
        <Grid
          item
          lg={2}
          container
          alignItems="center"
          direction="column"
          justify="center"
          className={classes.iconContainer}
        >
          <Grid item>
            <IconButton onClick={goNext}>
              <ArrowUpward className={classes.arrowIcon} />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton onClick={goPrev}>
              <ArrowDownward className={classes.arrowIcon} />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default AbhiprayCarousel;
